<template>
    <span v-html="displayValue"></span>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { parseIosViewPrice } from '../iosview';

export default {
    props: {
        value: {
            type: Object,
        },
    },
    computed: {
        ...mapState(['currency', 'enforceHardDisplay']),
        ...mapGetters(['product']),
        displayValue() {
            if (!this.currency) {
                return null;
            }
            if (window.App.isIosView && this.product.price?.iosview && this.product.price.full) {
                if (
                    this.product.price.full.currency_symbol === this.product.price.iosview.currencySymbol &&
                    !this.product.price.iosview.currency
                ) {
                    return this.value[this.product.price.full.currency].replace(' ', '&nbsp;');
                }
                const val = parseIosViewPrice(this.value[this.product.price.full.currency]);
                if (!val?.price) {
                    // the parse failed, just return the original value
                    return this.value[this.product.price.full.currency].replace(' ', '&nbsp;');
                }
                return (
                    this.product.price.iosview.currencySymbol +
                    Math.round(val.price * this.product.price.iosview.conversionRate).toLocaleString() +
                    this.product.price.iosview.currency
                );
            }
            if (this.enforceHardDisplay) {
                return `${this.value[this.product.price.full.currency].replace(' ', '&nbsp;')}&nbsp;${this.product.price.full.currency}`;
            }
            return this.value[this.product.price.full.currency].replace(' ', '&nbsp;');
        },
    },
};
</script>
